import React from 'react';
import {MainWrapper, Layout} from './Nutrition.Styles';
import {Header} from '../../components/organisms/Header/Header';
import {StickyNavigationLink} from '../../components/organisms/StickyNavigationLinks/StickyNavigationLinks'
import {MainContent} from '../../components/organisms/MainContent/MainContent';
import {RightScan} from '../../components/organisms/RightScan/RightScan';


export const Nutrition: React.FC = () => {
    const tag = 'nutrição';

  

    return(
    <Layout>
      <Header />
      <StickyNavigationLink onSearch={(tag) => console.log(tag)} />
      <MainWrapper>
        <MainContent tag={tag}/>
        <RightScan />
      </MainWrapper>
    </Layout>
    );

};